import { useAuth } from "@ssf/auth-components";

import { useAutoAsk } from "../lib/index.js";
import { AutoAskClubDialog, AutoAskMembershipDialog } from "./index.js";

export const AutoAsk = () => {
  const { user } = useAuth();

  const { data } = useAutoAsk({
    enabled: !!user && !user.profile.imperonated_by,
  });

  if (!data) {
    return null;
  }

  return (
    <>
      <AutoAskMembershipDialog clubs={data?.memberships} />
      <AutoAskClubDialog clubs={data?.clubs} />
    </>
  );
};
